var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNaverpayActive = function SvgNaverpayActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#naverpay_active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.262 4.072h3.85c.617 0 1.137.078 1.58.233.442.155.827.368 1.116.64.289.271.52.6.655.988.134.388.211.795.211 1.241v.31c0 .446-.076.854-.23 1.241a2.984 2.984 0 0 1-.674 1.008c-.29.291-.674.524-1.117.698-.443.175-.963.253-1.54.253h-2.369v4.226h-1.482V4.072Zm1.482 1.3v4.032h2.118c1.56 0 2.33-.64 2.33-1.939v-.271c0-.62-.193-1.086-.558-1.377-.366-.29-.905-.446-1.599-.446h-2.29ZM35.469 15.046c-.828 0-1.483-.213-1.964-.62-.481-.407-.732-.97-.732-1.706v-.407c0-.698.231-1.28.713-1.726.462-.446 1.232-.66 2.272-.66h2.08v-.484c0-.543-.136-.97-.405-1.221-.27-.272-.693-.407-1.29-.407-.597 0-.886.077-1.252.232a7.839 7.839 0 0 0-1.097.601l-.712-1.085a8.101 8.101 0 0 1 1.347-.737c.5-.213 1.078-.31 1.733-.31s.886.058 1.252.174c.385.116.712.29.982.504.27.233.48.504.635.834.154.33.231.698.231 1.105v5.758h-1.386v-.989c-.077.155-.193.291-.328.408a3.763 3.763 0 0 1-.442.33 2.857 2.857 0 0 1-.713.27c-.25.059-.558.098-.924.098v.038Zm2.368-3.877h-2.04c-.578 0-.983.116-1.214.33-.25.212-.365.523-.365.91v.214c0 .407.134.698.423.872.289.175.616.272 1.001.272.385 0 .674-.04.944-.136.27-.078.5-.213.731-.388.193-.155.347-.33.424-.523a2.04 2.04 0 0 0 .135-.756v-.815l-.039.02ZM44.324 13.281 46.48 6.71h1.522l-4.256 11.633-1.309-.466 1.06-2.81-2.985-8.357h1.578l2.176 6.572h.058Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.869 0H0v19h18.869V0Z",
    fill: "#00C73C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.938 13.842 7.896 9.344v4.498H4.719V5.156h3.215l3.042 4.498V5.156h3.177v8.686h-3.215Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "naverpay_active_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v19H0z"
  })))));
};

export default SvgNaverpayActive;